import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro" >
        <div className="overlay"       style={{
        background: "rgba(0,0,0,.40)",
        boxDecorationBreak: "clone",
        WebkitBoxDecorationBreak: "clone",
        padding: ".1em .25em",
        color: "#fff"
      }}>
          <div className="container" >
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1 
                style={{
        color: "white",
        fontSize: "42px",

        textShadow: `
          1px 0 0 black,
         -1px 0 0 black,
          0 1px 0 black,
          0 -1px 0 black,
          1px 1px 0 black,
         -1px 1px 0 black,
          1px -1px 0 black,
         -1px -1px 0 black
        `
      }}>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p  style={{
        color: "white",
        fontSize: "30px",

        textShadow: `
          0.5px 0 0 black,
         -0.5px 0 0 black,
          0 1px 0 black,
          0 -1px 0 black,
          0.5px 0.5px 0 black,
         -0.5px 0.5px 0 black,
          0.5px -0.5px 0 black,
         -0.5px -0.5px 0 black
        `
      }}>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href="#adventskalender"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  adventskalender
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
